import { useGetFrontAmbiti } from '@framework/api-client/api/inquiries-compile/ambiti-controller/ambiti-controller.ts';
import { CommonScopeTreeSelectInput } from '@framework/common-web/ui/scope/component/CommonScopeTreeSelectInput.tsx';

export interface IInquiryScopeTreeSelectInput {
  name: string;
  placeholder?: string;
}

/**
 * Input per la selezione dell'ambito di una domanda.
 */
export function InquiryScopeTreeSelectInput(
  props: IInquiryScopeTreeSelectInput,
) {
  const { name, placeholder } = props;
  const { data, isLoading, isFetching } = useGetFrontAmbiti();

  return (
    <CommonScopeTreeSelectInput
      data={data?.dati}
      isLoading={isLoading || isFetching}
      name={name}
      placeholder={placeholder}
    />
  );
}
